module.exports = __webpack_public_path__ + "static/img/产品中心-AI设备专家平台-case.6e597ff2.png";